import React from "react";
import { Modal } from "reactstrap";
import { TextField } from "shared";
import t from "utils/Lang";
import "./index.scss";

type ModalInputProps = {
  isOpen: boolean;
  toggle: (event?: React.KeyboardEvent<any>) => void;
  title: string;
  onConfirm: (text: string) => void;
  placeholder: string;
};

let text = "";

const ModalInput = ({
  isOpen,
  toggle,
  title,
  placeholder,
  onConfirm,
}: ModalInputProps) => {
  const apply = async () => {
    onConfirm(text);
  };
  return (
    <Modal isOpen={isOpen} toggle={toggle} style={{ padding: 30 }}>
      <div className="modal-input__header">
        <span className="modal-input__header__title">{title}</span>
      </div>
      <div className="modal-input__body">
        <TextField
          placeholder={placeholder}
          type="outline"
          style={{ width: "100%" }}
          onChange={(e) => {
            text = e.target.value;
          }}
          autoFocus
        />
      </div>
      <div className="modal-input__footer">
        <div className="modal-input__cancel-button" onClick={() => toggle()}>
          <span>{t().action__cancel}</span>
        </div>
        <div className="modal-input__confirm-button" onClick={apply}>
          <span>{t().action__confirm}</span>
        </div>
      </div>
    </Modal>
  );
};

export default ModalInput;
